import React, { useRef, useState } from "react";
import { TimelineHeader } from "./TimelineHeader";
import { TimelineActions } from "./TimelineActions";
import { TimelineCanvas } from "./TimelineCanvas";
import { TimelineModal } from "./TimelineModal";
import { useTimelineExport } from "./hooks/useTimelineExport";
import type { TimelineData } from "@/lib/chat/parseTimelineBlock";

interface TimelineProps {
  data: TimelineData;
}

export const Timeline: React.FC<TimelineProps> = ({ data }) => {
  const exportRef = useRef<HTMLDivElement>(null);
  const [expanded, setExpanded] = useState(false);
  const { exportPNG } = useTimelineExport(exportRef, data.title);

  return (
    <>
      <div className="relative w-full overflow-hidden rounded-xl border border-border/60 bg-card shadow-sm">
        <div ref={exportRef}>
          <TimelineHeader title={data.title} />
          <div className="bg-muted/20">
            <TimelineCanvas data={data} />
          </div>
        </div>
        <TimelineActions
          onDownload={exportPNG}
          onExpand={() => setExpanded(true)}
        />
      </div>

      <TimelineModal
        open={expanded}
        onClose={() => setExpanded(false)}
        data={data}
      />
    </>
  );
};
